import envVar from '../config/envVars';
import { TripStatus } from '../enums';
import httpGet from './httpClient/httpGet';
import httpPatch from './httpClient/httpPatch';
import httpPost from './httpClient/httpPost';

const fetchLiveTrips = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/trips/live/${school}`
  );
};

const updateLiveTrips = async (id: string, status: TripStatus) => {
  return httpPatch(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/trips/${id}`,
    {
      status
    }
  );
};

const sendLiveTripAlert = async (tripId: string) => {
  return httpPost(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/trip-alerts/`,
    { tripId }
  );
};

const liveTrips = { fetchLiveTrips, updateLiveTrips, sendLiveTripAlert };
export default liveTrips;
